export default {
    state: () => ({}),
};
